<template>
  <v-dialog
    v-model="show"
    :max-width="maxWidth"
    @input="closeDialog"
    scrollable
    v-if="!!vaccines && vaccines.length > 0"
  >
    <v-card elevation="0">
      <v-card-title class="d-flex column-gap-5 align-center pb-2 text-h5"
        >Informações das doses de {{ vaccines[0].name }} - {{ vaccines[0].commercialName }}
      </v-card-title>

      <v-col v-for="(vaccine, index) in vaccines" :key="index">
        <v-row class="ma-4">
          <field-label :label="`Anotações da dose dia ${$util.toFormattedDate(vaccine.date)}:`" />
          <v-btn x-small icon @click="deleteNotes(vaccine)"><v-icon>mdi-trash-can</v-icon></v-btn>
          <v-btn x-small icon @click="saveNotes(vaccine, temporaryNotes[vaccine.date + vaccine.notes])"
            ><v-icon>mdi-check-bold</v-icon></v-btn
          >
        </v-row>
        <text-field
          :placeholder="vaccine.notes === '' ? 'Sem anotações' : vaccine.notes"
          v-model="temporaryNotes[vaccine.date + vaccine.notes]"
        />
      </v-col>
    </v-card>
  </v-dialog>
</template>

<script>
import FieldLabel from '@/components/FieldLabel.vue'
import TextField from '@/components/TextField.vue'

export default {
  name: 'VaccineInfoDialog',
  components: { FieldLabel, TextField },
  props: {
    maxWidth: {
      type: [String, Number],
      default: '60vw',
    },
  },
  data() {
    return {
      show: false,
      vaccines: null,
      temporaryNotes: {},
    }
  },
  methods: {
    openDialog(vaccines) {
      this.vaccines = vaccines.sort((vaccineA, vaccineB) => {
        let dateA = new Date(vaccineA.date)
        let dateB = new Date(vaccineB.date)
        return dateA - dateB
      })
      this.show = true
    },
    closeDialog() {
      this.show = false
      this.vaccine = null
    },
    saveNotes(vaccine, notesToSave) {
      if (!!notesToSave) {
        vaccine.notes = notesToSave
      }
    },
    async deleteNotes(vaccine) {
      if (
        await this.$root.confirm(
          `Isso apagará as anotações do dia ${this.$util.toFormattedDate(vaccine.date)}, continuar?`,
        )
      ) {
        vaccine.notes = ''
      }
    },
  },
}
</script>

<style scoped></style>
